module.exports = __webpack_public_path__ + "img/BABO-01.6e05948a.png";